import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Wer kann an den Reisen teilnehmen?',
    answer: 'Unsere Reisen richten sich an Models und Fotografen, die hochwertigen visuellen Content erstellen möchten. Models können sich direkt bewerben. Fotografen können teilnehmen, wenn sie ein Model mitbringen, das zu unserem visuellen Konzept passt.'
  }, {
    question: 'Was bedeutet TFP?',
    answer: "TFP steht für 'Time for Prints' — ein Modell der kreativen Zusammenarbeit, bei dem alle Beteiligten ihre Zeit und Fähigkeiten einbringen und im Gegenzug die entstandenen Bilder für ihr Portfolio nutzen können."
  }, {
    question: 'Was ist im Preis enthalten?',
    answer: 'Der Preis von ca. 350 € pro Person beinhaltet die Unterkunft in unserer exklusiven Cliff Villa mit Meerblick und Privatpool. Hinzu kommt eine Verpflegungspauschale von ca. 50 € — Überschüsse werden selbstverständlich zurückerstattet. Flüge und persönliche Ausgaben sind nicht enthalten.'
  }, {
    question: 'Wie läuft die Auswahl ab?',
    answer: 'Nach deiner Bewerbung prüfen wir dein Portfolio und deinen Instagram-Auftritt. Wir achten auf visuellen Stil, Professionalität und ob du gut zur Gruppe passt. Du erhältst innerhalb weniger Tage eine Rückmeldung.'
  }, {
    question: 'Wie läuft die Anreise ab Flughafen Nürnberg ab?',
    answer: 'Die Anreise erfolgt in der Regel ab Flughafen Nürnberg per Flug nach Portugal. Nach der Landung organisieren wir einen oder mehrere Mietwagen und holen die Models direkt ab. Der Transfer zur Unterkunft ist also bereits eingeplant, sodass sich niemand selbst um die Weiterreise kümmern muss. Je nach Gruppengröße verteilen wir die Teilnehmerinnen auf die Fahrzeuge und fahren gemeinsam zur Unterkunft in Burgau. So ist die Anreise vor Ort unkompliziert, entspannt und von Anfang an gut organisiert.'
  }, {
    question: 'Muss ich mich vor Ort selbst um den Transfer kümmern?',
    answer: 'Nein. Nach der Ankunft organisieren wir einen oder mehrere Mietwagen und bringen dich direkt vom Flughafen zur Unterkunft in Burgau.'
  }, {
    question: 'Gibt es Einzelzimmer oder geteilte Unterkünfte?',
    answer: 'In der Unterkunft gibt es verschiedene Zimmergrößen: Schlafzimmer mit großen Doppelbetten, Zimmer mit Einzelbetten, Zimmer mit Einzel- und Doppelbett-Kombination, ein Zimmer mit Etagenbetten sowie ein Schlafsofa im Wohnzimmer. Bei der Bewerbung kannst du angeben, wie du untergebracht werden möchtest. Einzelzimmer sind begrenzt verfügbar und mit einem Aufpreis verbunden. Wir empfehlen, sich ein Zimmer zu teilen, um den Preis niedrig zu halten.'
  }, {
    question: 'Gibt es eine Anzahlung?',
    answer: 'Der gesamte Preis für die Unterkunft ist sofort nach Zusage fällig. Die Verpflegung wird vor Ort geregelt. Sollte der Trip aus irgendwelchen Gründen seitens der Organisatoren nicht stattfinden, werden angezahlte Kosten vollständig erstattet.'
  }, {
    question: 'Kann ich zurücktreten?',
    answer: 'Ja. Bis zu 2 Wochen vor dem Trip kannst du kostenlos zurücktreten. Bei einem Rücktritt 1–2 Wochen vorher erstatten wir 50 % der Anzahlung. Bei weniger als 1 Woche erstatten wir 25 % der angezahlten Kosten.'
  }, {
    question: 'Welche Outfits soll ich einpacken?',
    answer: 'Passende Outfits zur Urlaubslocation: helle Kleider, Bikinis, Unterwäsche für Lingerie-Shoots. Alles, was zum Sommer und zur Küstenkulisse passt.'
  }, {
    question: 'Welche Arten von Shootings sind geplant?',
    answer: 'Es gibt zwei Arten von Content: Family-friendly Instagram-Content zum Aufbau von Reichweite auf TFP-Basis, sowie Spicy Content für Payplattformen — ebenfalls auf TFP-Basis.'
  }, {
    question: 'Können Fotografen auch ohne Model teilnehmen?',
    answer: 'Nein, Fotografen können nur teilnehmen, wenn sie ein Model mitbringen, das zu unserem visuellen Konzept passt. Dies stellt sicher, dass die kreative Qualität und der Zusammenhalt jeder Reise gewährleistet sind.'
  }, {
    question: 'Welche Voraussetzungen gelten für Fotografen?',
    answer: 'Ein hochwertiges Portfolio ist Voraussetzung. Außerdem muss mindestens ein Model mitgebracht werden, das zum visuellen Konzept der Reise passt.'
  }, {
    question: 'Darf ich eine Begleitperson mitbringen?',
    answer: 'Primär sind die Plätze für Kreative reserviert. Jedoch kann gerne nachgefragt werden, ob eine Begleitperson möglich ist — je nach Verfügbarkeit.'
  }, {
    question: 'Wofür dürfen die Bilder verwendet werden?',
    answer: 'Die Bilder dürfen für private und kommerzielle Zwecke verwendet werden.'
  }, {
    question: 'Wer erhält die entstandenen Bilder?',
    answer: 'Die Bilder stehen jeweils dem Fotografen und dem jeweiligen Model zur Verfügung. Nach der Reise werden sie per Cloud-Zugriff unbearbeitet bereitgestellt. Bearbeitete Bilder werden nach und nach auf Instagram veröffentlicht und dem Model ebenfalls zur Verfügung gestellt.'
  }, {
    question: 'Darf Content für Instagram, Patreon und andere Plattformen genutzt werden?',
    answer: 'Ja, der entstandene Content darf auf allen Plattformen genutzt werden — Instagram, Patreon, Portfolio-Websites und weitere.'
  }, {
    question: 'Gibt es Regeln zu Behind-the-Scenes-Aufnahmen?',
    answer: 'In Absprache mit den sichtbaren Personen ist das kein Problem. Bitte vorher kurz fragen.'
  }, {
    question: 'An wen kann ich mich bei Fragen wenden?',
    answer: 'whatsapp'
  }];
  return <section className="py-24 md:py-32 px-6 bg-[#f5f5f7]" data-id="element-207">
      <div className="max-w-3xl mx-auto" data-id="element-208">
        <div className="text-center mb-16" data-id="element-209">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-210">
            Häufige Fragen
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e]" data-id="element-211">
            Alles, was du wissen musst.
          </h2>
        </div>

        <div className="space-y-4" data-id="element-212">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const isWhatsApp = faq.answer === 'whatsapp';
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: Math.min(index * 0.05, 0.5)
          }} className={`border rounded-xl overflow-hidden transition-colors duration-300 shadow-sm ${isOpen ? 'bg-white border-brand-accent/40' : 'bg-white border-[#e2e2e6] hover:border-[#c0c0c8]'}`} data-id="element-213">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-214">
                  <span className={`font-medium pr-8 ${isOpen ? 'text-brand-accent' : 'text-[#1a1a2e]'}`} data-id="element-215">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className={`flex-shrink-0 ${isOpen ? 'text-brand-accent' : 'text-[#8a8a9a]'}`} data-id="element-216">
                    <ChevronDownIcon size={20} data-id="element-217" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-218">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-219">
                      <div className="px-6 pb-6 text-[#4a4a5a] font-light leading-relaxed" data-id="element-220">
                        {isWhatsApp ? <div data-id="element-221">
                            <p className="mb-3" data-id="element-222">
                              Bei Fragen kannst du dich jederzeit per WhatsApp
                              an Dimi wenden:
                            </p>
                            <a href="https://wa.me/+4917621226068" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#25D366]/10 text-[#25D366] border border-[#25D366]/30 rounded-lg hover:bg-[#25D366]/20 transition-colors font-medium text-sm" data-id="element-223">
                              <MessageCircleIcon size={16} data-id="element-224" />
                              WhatsApp: +49 176 21226068
                            </a>
                          </div> : faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}